/**
 * Constants for Masonry Layout (React Grid Layout)
 *
 * These constants match the original values from card-surface-ui
 * to ensure consistent behavior after migration.
 */

export const RowHeightPx = 50;
export const MinCardHeightPx = 200;
export const SmallerRowHeightPx = 10;
export const RowMarginPx = 10;
export const ColMarginPx = 10;
export const GridCols = 2;
export const MinCardRows = MinCardHeightPx / RowHeightPx;